/**
 * ToolLibraryApi
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Represents the type of tool import.
 */
export const ToolDataImportModuleDataContractsToolImportJobTypeDto = {
  Undefined: 'Undefined',
  DataOnboarding: 'DataOnboarding',
  WebCatalog: 'WebCatalog',
  DemoData: 'DemoData',
  TestData: 'TestData',
  TdmPackage: 'TdmPackage',
  TfsPackage: 'TfsPackage',
} as const;

export type ToolDataImportModuleDataContractsToolImportJobTypeDto =
  (typeof ToolDataImportModuleDataContractsToolImportJobTypeDto)[keyof typeof ToolDataImportModuleDataContractsToolImportJobTypeDto];
